import { createFunnelPageConfig, LandingPageKind, templateSection, type LandingTemplate } from "../../template";
import {
  bikini2026CheckoutProps,
  bikini2026FaqProps,
  bikini2026FooterProps,
  bikini2026HeaderProps,
  bikini2026HeroProps,
  bikini2026IncludedProps,
  bikini2026MetamorphosesProps,
  bikini2026OfferProps,
  bikini2026PainProps,
  bikini2026RewardProps,
  bikini2026StickyCtaProps,
  bikini2026TimelineProps,
  bikini2026TransformationsProps,
  bikiniFunnelCheckoutProps,
  bikiniFunnelThankYouProps,
} from "./content";

const landingConfig = createFunnelPageConfig({
  title: "6 Tygodni do Bikini | Program Hollywood",
  description:
    "Wyzwanie online dla kobiet: trening 45 minut co drugi dzień, prosta dieta i aplikacja. Schudnij 5 kg i odbierz 300% dofinansowania.",
  ogImage: "/assets/main.jpeg",
  pageName: "bikini-2026-landing",
  // `LandingLayout` light, forced light, hidden theme switcher (its default accent is gold).
  shell: "landing",
  accentColor: "gold",
  backgroundClassName: "bg-[#f3f3f3]",
  sections: [
    templateSection("effects", "funnelLandingEffects", { stepSlug: "landing", facebookPixel: true }),
    templateSection("header", "bikini2026Header", bikini2026HeaderProps),
    templateSection("hero", "bikini2026Hero", bikini2026HeroProps, { trackingName: "hero" }),
    templateSection("transformations", "bikini2026Transformations", bikini2026TransformationsProps, {
      trackingName: "transformations",
    }),
    templateSection("pain", "bikini2026Pain", bikini2026PainProps, { trackingName: "pain" }),
    templateSection("included", "bikini2026Included", bikini2026IncludedProps, { trackingName: "included" }),
    templateSection("timeline", "bikini2026Timeline", bikini2026TimelineProps, { trackingName: "timeline" }),
    templateSection("reward", "bikini2026Reward", bikini2026RewardProps, { trackingName: "reward" }),
    templateSection("metamorphoses", "bikini2026Metamorphoses", bikini2026MetamorphosesProps, {
      trackingName: "metamorphoses",
    }),
    // Not `oferta`: the offer block itself carries that anchor id.
    templateSection("offer", "bikini2026Offer", bikini2026OfferProps, { trackingName: "offer" }),
    templateSection("faq", "bikini2026Faq", bikini2026FaqProps, { trackingName: "faq" }),
    templateSection("footer", "bikini2026Footer", bikini2026FooterProps),
    templateSection("sticky-cta", "bikini2026StickyCta", bikini2026StickyCtaProps),
  ],
});

export const bikini2026Templates: LandingTemplate[] = [
  {
    key: "bikini-2026-landing",
    name: "6 Tygodni do Bikini 2026 - landing",
    kind: LandingPageKind.Landing,
    sourceRoute: "/oferta/6tygodnidobikini-2026/start",
    config: { ...landingConfig, seo: { ...landingConfig.seo, favicon: "/favicon.png" } },
  },
  {
    key: "bikini-2026-checkout",
    name: "6 Tygodni do Bikini 2026 - checkout",
    kind: LandingPageKind.Checkout,
    sourceRoute: "/oferta/6tygodnidobikini-2026/checkout",
    config: createFunnelPageConfig({
      title: bikini2026CheckoutProps.seoTitle,
      pageName: "bikini-2026-checkout",
      shell: "embedding",
      accentColor: "ruby",
      backgroundClassName: "",
      sections: [templateSection("checkout", "bikini2026Checkout", bikini2026CheckoutProps)],
    }),
  },
  {
    key: "bikini-checkout",
    name: "6 Tygodni do Bikini - checkout",
    kind: LandingPageKind.Checkout,
    sourceRoute: "/oferta/6tygodnidobikini-promocja/checkout",
    config: createFunnelPageConfig({
      title: "6 Tygodni do Bikini - płatność",
      pageName: "bikini-checkout",
      shell: "embedding",
      accentColor: "crimson",
      backgroundClassName: "",
      sections: [templateSection("checkout", "bikiniFunnelCheckout", bikiniFunnelCheckoutProps)],
    }),
  },
  {
    key: "bikini-dziekujemy",
    name: "6 Tygodni do Bikini - podziękowanie",
    kind: LandingPageKind.ThankYou,
    sourceRoute: "/oferta/6tygodnidobikini-promocja/ty",
    config: createFunnelPageConfig({
      title: "6 Tygodni do Bikini - dziękujemy",
      pageName: "bikini-thank-you",
      shell: "embedding",
      accentColor: "crimson",
      backgroundClassName: "",
      sections: [templateSection("thank-you", "bikiniFunnelThankYou", bikiniFunnelThankYouProps)],
    }),
  },
];
